<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-12">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Acompanhamento Integração
        </p>
      </div>
    </div>
    <div
      class="row col-12 row-input-container text-weight-bold text-brand-5 q-mt-md q-gutter-sm"
    >
      <div class="col-md col-xs-6 input-unidade-container">
        <div class="texto-titulo-input">Unidade</div>

        <lista-unidades-select
          v-model="filtros.unidade"
        ></lista-unidades-select>
      </div>
      <div class="col-md col-xs-5 input-unidade-container">
        <div class="texto-titulo-input">Data Inicial</div>
        <q-input
          v-model="filtros.dataInicial"
          dense
          outlined
          class="texto-titulo-input"
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
          :rules="[
            (val) => val == '' || val.length == 10 || 'Digite a Data Completa',
          ]"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="filtros.dataInicial"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  :rules="[
                    (val) =>
                      val == '' || val.length == 10 || 'Digite a Data Completa',
                  ]"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="col-md col-xs-6 input-unidade-container">
        <div class="texto-titulo-input">Data Final</div>
        <q-input
          v-model="filtros.dataFinal"
          dense
          outlined
          class="texto-titulo-input"
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
          :rules="[
            (val) => val == '' || val.length == 10 || 'Digite a Data Completa',
          ]"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="filtros.dataFinal"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  :rules="[
                    (val) =>
                      val == '' || val.length == 10 || 'Digite a Data Completa',
                  ]"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="col-md col-xs-5 input-unidade-container">
        <div class="texto-titulo-input">Numero Requisição</div>
        <q-input
          dense
          outlined
          class="texto-titulo-input"
          v-model="filtros.requisicao"
          maxlength="10"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </div>
      <div class="col-md col-xs-11 input-unidade-container">
        <div class="texto-titulo-input">Numero Reserva</div>
        <q-input
          dense
          outlined
          v-model="filtros.reserva"
          maxlength="10"
          class="texto-titulo-input"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </div>
    </div>
    <div
      class="row col-12 row-input-container text-weight-bold text-brand-5 q-mt-sm q-gutter-sm"
    >
      <div class="col-md col-xs-6 input-unidade-container">
        <div class="texto-titulo-input">Operação</div>

        <q-select
          v-model="filtros.operacao"
          option-value="value"
          label="Selecione o Status"
          label-color="grey-6"
          :options="operacaoOptions"
          dense
          map-options
          emit-value
          outlined
        />
      </div>
      <div class="col-md col-xs-5 input-unidade-container">
        <div class="texto-titulo-input">Com erro</div>

        <q-select
          v-model="filtros.erro"
          option-value="value"
          label="Selecione o Status"
          label-color="grey-6"
          :options="erroOptions"
          dense
          map-options
          emit-value
          outlined
        />
      </div>

      <div class="col-md col-xs-6 input-unidade-container">
        <div class="texto-titulo-input">Solicitante</div>

        <SelecaoSolicitante @emitirFuncionario="receberFuncionario" />
      </div>

      <div class="col-md col-xs-5 input-unidade-container">
        <div class="texto-titulo-input">Produto</div>
        <q-input
          dense
          outlined
          v-model="filtros.produto"
          maxlength="10"
          class="texto-titulo-input"
        />
      </div>

      <div class="col-md col-xs-11 input-unidade-container">
        <div class="texto-titulo-input">Quantidade de Linhas</div>
        <q-select
          v-model="pagination.rowsPerPage"
          option-label="label"
          option-value="value"
          label-color="grey-6"
          :options="quantidadePaginas"
          dense
          outlined
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="q-ml-md text-brand-5 text-weight-bold titulo-tabela">
        Listagem de Requisições
      </div>
      <q-table
        table-header-class="bg-accent text-width-bold text-brand-5 text-weight-bold titulo-tabela"
        :rows="rows"
        :columns="columns"
        :loading="disable"
        dense
        color="primary"
        row-key="voucherId"
        flat
        :class="{ 'tabela-tamanho-fixo': !mobile }"
        :grid="mobile"
        v-model:pagination="pagination"
        no-data-label="Nenhuma requisição encontrada."
        hide-pagination
        @request="handleRequest"
      >
        <template v-slot:item="props">
          <div class="q-pa-xs col-xs-12 col-sm-12 col-md-12">
            <div class="row card">
              <div class="col-12">
                <q-card-section class="row text-brand-5 text-grid-table">
                  <div class="col-12">
                    <span
                      ><strong>Unidade:</strong>
                      {{ props.row.unidade_nome }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Nº Requisiçãpo:</strong>
                      {{ props.row.voucher_id }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Nº Reserva:</strong>
                      {{ props.row.numero_reserva }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Matrícula Solicitante:</strong>
                      {{ props.row.solicitante_matricula }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Nome Solicitante:</strong>
                      {{ props.row.solicitante_nome }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Código Produto:</strong>
                      {{ props.row.produto_codigo }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Descrição Produto:</strong>
                      {{ props.row.produto_descricao }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Quantidade Solicitada:</strong>
                      {{ props.row.quantidade_solicitada }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Quantidade Atendida:</strong>
                      {{ props.row.quantidade_atendida }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Data Entrega:</strong>
                      {{
                        props.row?.data_finalizacao_voucher
                          ?.split(" ")[0]
                          ?.split("-")
                          ?.reverse()
                          .join("/")
                      }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Data Integração:</strong>
                      {{
                        props.row?.data_operacao
                          ?.split(" ")[0]
                          ?.split("-")
                          ?.reverse()
                          .join("/")
                      }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Operação:</strong>
                      {{ props.row?.operacao }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Mensagem da Operação:</strong>
                      {{ props.row?.mensagem_operacao }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Sucesso:</strong>
                      {{ props.row?.sucesso ? "Sim" : "Não" }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Reenviado:</strong>
                      {{ props.row?.reenviado ? "Sim" : "Não" }}</span
                    >
                  </div>
                </q-card-section>
              </div>
              <div class="col-12">
                <div class="text-brand-5 btn-grid-container">
                  <div class="row">
                    <div class="column col">
                      <q-btn
                        class="btn-grid-action"
                        stack
                        no-caps
                        label="Reenviar"
                        icon="refresh"
                        :disable="
                          props.row.sucesso == 1 || props.row.reenviado == 1
                            ? true
                            : false
                        "
                        @click="
                          reenviar(props.row.voucher_id, props.row.produto_id)
                        "
                        :color="
                          props.row.sucesso == 1 || props.row.reenviado == 1
                            ? 'greey'
                            : 'primary'
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template #body-cell-produtos="props">
          <q-td :props="props">
            <div v-for="(produto, index) in props.row.produtos" :key="index">
              <span class="q-mt-sm"
                ><span style="font-weight: bolder">{{
                  produto.quantidade
                }}</span>
                x {{ produto.nome }}</span
              >
            </div>
          </q-td>
        </template>
        <template #body-cell-sucesso="props">
          <q-td :props="props">
            <div>
              <span v-if="props.row.sucesso == '1'">SIM</span>

              <span v-else>NÃO</span>
            </div>
          </q-td>
        </template>
        <template #body-cell-reenviado="props">
          <q-td :props="props">
            <div>
              <span v-if="props.row.reenviado == '1'">SIM</span>

              <span v-else>NÃO</span>
            </div>
          </q-td>
        </template>
        <template #body-cell-renviar="props">
          <q-td :props="props">
            <div>
              <q-btn
                @click="reenviar(props.row.voucher_id, props.row.produto_id)"
                icon="refresh"
                round
                :color="
                  props.row.sucesso == 1 || props.row.reenviado == 1
                    ? 'greey'
                    : 'primary'
                "
                flat
                :disable="
                  props.row.sucesso == 1 || props.row.reenviado == 1
                    ? true
                    : false
                "
              />
            </div>
          </q-td>
        </template>
      </q-table>
    </div>
    <div class="row justify-center q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :direction-links="true"
        :size="mobile ? 'md' : 'sm'"
        :max-pages="6"
      />
    </div>
  </q-page>
</template>

<script>
import { ref, watch, computed, onMounted } from "vue";
import { useStore } from "vuex";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import SelecaoSolicitante from "../components/SelecaoSolicitante.vue";
import { watchDebounced } from "@vueuse/core";
import { useQuasar } from "quasar";

const columns = [
  {
    name: "unidade_nome",
    label: "Unidade",
    field: "unidade_nome",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "voucher_id",
    label: "Numero Requisição",
    field: "voucher_id",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },

  {
    name: "numero_reserva",
    label: "Numero Reserva",
    field: "numero_reserva",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "solicitante_matricula",
    label: "Matricula Solicitante",
    field: "solicitante_matricula",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "solicitante_nome",
    label: "Nome Solicitante",
    field: "solicitante_nome",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "produto_codigo",
    label: "Codigo Produto",
    field: "produto_codigo",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "produto_descricao",
    label: "Descrição do Produto",
    field: "produto_descricao",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "quantidade_solicitada",
    label: "Quantidade Solicitada",
    field: "quantidade_solicitada",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "quantidade_atendida",
    label: "Quantidade Atendida",
    field: "quantidade_atendida",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "reservaSap",
    label: "Data Entrega",
    field: (row) =>
      row?.data_finalizacao_voucher
        ? row?.data_finalizacao_voucher
            .split(" ")[0]
            .split("-")
            .reverse()
            .join("/")
        : "",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "data_operacao",
    label: "Data Integração",
    field: (row) =>
      row?.data_operacao
        ? row?.data_operacao.split(" ")[0].split("-").reverse().join("/")
        : "",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "operacao",
    label: "Operação ",
    field: "operacao",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "numero_migo",
    label: "Documento",
    field: "numero_migo",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "mensagem_operacao",
    label: "Mensagem da Operação",
    field: "mensagem_operacao",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "sucesso",
    label: "Sucesso",
    field: "sucesso",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "reenviado",
    label: "Reenviado ",
    field: "reenviado",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "renviar",
    label: "Renviar",
    field: "renviar",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
];

export default {
  components: {
    ListaUnidadesSelect,
    SelecaoSolicitante,
  },
  setup() {
    const store = useStore();

    const quasar = useQuasar();

    const filtros = ref({
      unidade: "",

      dataInicial: "",
      dataFinal: "",
      requisicao: null,
      reserva: null,
      operacao: "",
      erro: "",
      produto: "",
    });

    const observacao = ref("");
    const solicitanteMatricula = ref(null);
    const solicitantePesquisa = ref(null);

    const rows = ref([]);

    const listaPicking = ref([]);

    const disable = ref(false);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 10,
    });
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const getDados = async (page = 1, rowsPerPage = 10) => {
      try {
        let response = await store.dispatch("pkg/getListagemIntegracao", {
          page: page,
          per_page: rowsPerPage,
          unidade_id: filtros.value.unidade.id,
          data_inicial: filtros.value.dataInicial
            ? filtros.value.dataInicial.split("/").reverse().join("-")
            : undefined,
          data_final: filtros.value.dataFinal
            ? filtros.value.dataFinal.split("/").reverse().join("-")
            : undefined,
          com_erro: filtros.value.erro != "" ? filtros.value.erro : undefined,
          operacao:
            filtros.value.operacao != "" ? filtros.value.operacao : undefined,
          voucher_id:
            filtros.value.requisicao != ""
              ? filtros.value.requisicao
              : undefined,
          numero_reserva:
            filtros.value.reserva != "" ? filtros.value.reserva : undefined,
          produto:
            filtros.value.produto != "" ? filtros.value.produto : undefined,

          solicitante:
            solicitanteMatricula.value && solicitanteMatricula.value.name
              ? solicitanteMatricula.value.name
              : undefined,
        });

        rows.value = response.data.data;
        pagination.value.rowsPerPage = response.data.per_page;
        pagination.value.rowsNumber = response.data.total;
        pagination.value.page = response.data.current_page;

        disable.value = false;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const reenviar = async (voucherId, productId) => {
      try {
        await store.dispatch("pkg/reenviarListagemIntegracao", {
          voucherId,
          productId,
        });

        quasar.notify({
          message: "Reenviado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados(pagination.value.page, pagination.value.rowsPerPage);
      } catch (error) {
        quasar.notify({
          message: "Erro a o reenviar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const receberFuncionario = (value) => {
      solicitanteMatricula.value = value;
      solicitantePesquisa.value = value?.nome;
    };

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        filtros.value.unidade = JSON.parse(getunidade);
        getDados();
      }

      setTimeout(() => {
        if (
          store.state.autenticacao.cliente.includes("staging-cerradinho") ||
          store.state.autenticacao.cliente.includes("cerradinho")
        ) {
          filtros.value.unidadeDestino = store.state.org.todaUnidades[0];
        }
      }, 1000);
    };

    onMounted(getUnidade);

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        filtros.value.unidade = store.state.org.unidadeData;
      }
    );
    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watchDebounced(
      [
        () => filtros.value.unidade,
        () => filtros.value.dataInicial,
        () => filtros.value.dataFinal,
        () => filtros.value.requisicao,
        () => filtros.value.reserva,
        () => filtros?.value?.operacao,
        () => filtros?.value?.erro,
        () => filtros.value.produto,
        () => solicitanteMatricula.value,
        () => pagination.value.rowsPerPage,
      ],
      () => {
        if (
          filtros.value.dataInicial != "" &&
          filtros.value.dataInicial.length != 10
        ) {
          return;
        }
        if (
          filtros.value.dataFinal != "" &&
          filtros.value.dataFinal.length != 10
        ) {
          return;
        }
        handleRequest();
      },
      { debounce: 400 }
    );

    return {
      getUnidade,
      receberFuncionario,
      solicitanteMatricula,
      solicitantePesquisa,
      filtros,
      listaPicking,
      pagination,
      disable,

      columns,
      mobile,
      getDados,
      handleRequest,
      reenviar,
      erroOptions: [
        { label: "Sim", value: "sim" },
        { label: "Não", value: "nao" },
      ],
      operacaoOptions: [
        { label: "Criação", value: "Criação" },
        { label: "Estorno", value: "Estorno" },
        { label: "Cancelamento", value: "Cancelamento" },
        { label: "Baixa", value: "baixa" },
      ],

      quantidadePaginas: ["10", "30", "50", "70", "100"],
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),

      rows,
      observacao,
    };
  },
};
</script>

<style scoped>
.titulo-tabela {
  font-size: 18px;
}
.container-grid-table {
  border: 1px solid #707070;
  font-size: 12px;
}
.texto-coluna-card {
  font-size: 14px;
}
.texto-titulo {
  font-size: 20px;
}
.card {
  border: 1px solid #707070;
}
.text-grid-table {
  font-size: 19px;
}
@media (max-width: 1024px) {
  .texto-titulo-input {
    font-size: 14px;
  }
  .titulo-tabela {
    font-size: 20px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .btn-grid {
    font-size: 19px;
  }
  .btn-grid-action {
    font-size: 16px;
    border-radius: 0px;
  }
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 17px;
  }
  .texto-titulo-input {
    font-size: 15px;
  }
  .titulo-tabela {
    font-size: 15px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .texto-colunas {
    font-size: 10px;
  }
  .btn-grid {
    font-size: 12px;
  }
  .text-grid-table {
    font-size: 15px;
  }
}
</style>
